import './footer.css';

export default function Card(props) {

    return(
        <footer className="footer">
            <p>Esta pagina no se encuentra asociada de ninguna forma a la Formula 1 o la FIA.</p>
            <p>Ninguno de los productos presentes se encuentra realmente a la venta, la pagina fue creada para un proyecto y no tiene fines comerciales</p>
            <hr className="white-line"/>
            <p className="sign">Ignacio Cordiglia - 2022</p>
        </footer>
    )
  }
